module.exports = __webpack_public_path__ + "static/mr-concert-performance-01-fdcc0249a09ef7b65f9ea8b3a9105260.jpg";